// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginHelp_root__1sRRq","paper":"LoginHelp_paper__14aLN","title":"LoginHelp_title__gm9-K"};